<script setup>
/**
 * FormControlPagesType
 * Composition-based wrapper around the core drop-down select component.
 * Safeguard Layer: Evaluates page creation state on mount, permanently
 * forcing the field to read-only mode for saved entities unless beta is enabled.
 */
import { computed, onMounted, getCurrentInstance } from 'vue';
import FormControlTypeSelect from "../form-control-type/FormControlTypeSelect.vue";

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    options: {
        type: Array,
        default: () => []
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const betaMode = computed(() => store.state.betaMode || false);

// --- Lifecycle ---

onMounted(() => {
    /**
     * Safety Lock Mechanism: If this is an existing database record,
     * lock down modifications to protect structural node mapping rules.
     */
    if (props.currentData?.id && !betaMode.value && props.field) {
        props.field.readonly = true;
    }
});
</script>

<template>
    <FormControlTypeSelect
        v-bind="$props"
        v-on="$listeners"
    />
</template>